import React, { createContext } from 'react';
import { Button, Modal, Space } from 'antd';
import { triggerEvent, useEventListener } from "@/common/event";
import {useTranslation} from "react-i18next";
import {t} from "i18next";

/** confirm确认框 */
export const confirmServer = {
    /** resolve任务map */
    resolveMap: new Map(),
    /** 打开confirm弹窗 */
    open(title: string, content: string, okText = t("Ok"), cancelText = t("Cancel")) {
        return new Promise((resolve) => {
            const id = crypto.randomUUID();
            triggerEvent("do-confirm", { title, content, okText, cancelText, id });
            confirmServer.resolveMap.set(id, resolve)
        })
    },
    /** 弹窗组件 */
    UseContext() {
        const [modal, contextHolder] = Modal.useModal();
        useEventListener("do-confirm", async ({ detail }) => {
            const confirmed = await modal.confirm(detail);
            confirmServer.resolveMap.get(detail.id)?.(confirmed)
            confirmServer.resolveMap.delete(detail.id)
        });
        return <div>{contextHolder}</div>

    }
}
